import React from 'react';
import styles from "./textSection.module.scss";
import { renderWithBreaks } from '@utils/translations';

const TextSection = ({ title, text, subtitle }) => (
  <div className={styles.textSection}>
    <h2>{title}</h2>
    <p>{renderWithBreaks(text)}</p>
    <h4>{subtitle}</h4>
  </div>
);

export default TextSection;
